import { deleteToken } from '../../reduxActions/tokenSlice';
import {
  useAppDispatch,
  useAppSelector,
} from '../../storeHook';
import { Token } from '../types';

export const getToken = () => {
  const stateToken = useAppSelector(
    (state) => state.token
  ).token;
  return stateToken
    ? stateToken
    : (
        JSON.parse(
          localStorage.getItem('authToken') as string
        ) as Token | undefined
      )?.token;
};

export const useLogOut = () => {
  const dispatch = useAppDispatch();
  const doLogOut = () => {
    localStorage.removeItem('authToken');
    dispatch(deleteToken());
    window.location.reload();
  };

  return doLogOut;
};
